import { useState, useEffect } from "react";
import "./Dropdown.css";
import { FilterOption } from "../TabbedResourceGrid/BlogFilters";
import Icon from "../Icon";

interface DropdownProps {
  options: any;
  selectedFilters: FilterOption[];
  onChange: Function;
  title?: string;
  multiSelect?: boolean;
  labelClearAll?: string;
}

export const Dropdown = ({
  options,
  onChange,
  title,
  selectedFilters = [],
  multiSelect = true,
  labelClearAll = "Clear All"
}: DropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState<FilterOption[]>(selectedFilters);

  // Sync the dropdown state with the selectedFilters prop from the parent
  useEffect(() => {
    setSelectedOptions(selectedFilters || []);
  }, [selectedFilters]);

  const handleOptionClick = (option: FilterOption) => {
    // TODO - REFACTOR, this feels a bit yuck
    let updatedSelectedOptions;
    if (multiSelect) {
      // Handle multi-select behavior
      if (selectedOptions && selectedOptions?.find((selectedOption: any) => selectedOption?.id === option?.id)) {
        updatedSelectedOptions = selectedOptions?.filter((selectedOption: any) => selectedOption?.id !== option?.id);
      } else {
        selectedOptions?.push(option);
        updatedSelectedOptions = [...selectedOptions];
      }
    } else {
      // Handle single-select behavior (sort)
      updatedSelectedOptions = [option];
    }

    setSelectedOptions(updatedSelectedOptions);
    onChange(updatedSelectedOptions);
  };

  const handleClearAll = () => {
    setSelectedOptions([]);
    onChange([]);
  };

  const handleBlur = (e: React.FocusEvent<HTMLDivElement>) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setIsOpen(false);
    }
  };

  return (
    <div
      className={`t2-dropdown ${isOpen ? "t2-dropdown--open" : ""}`}
      tabIndex={0}
      onBlur={handleBlur}
    >
      <div
        className={`t2-dropdown__trigger 
          
        `}
        onClick={() => setIsOpen(!isOpen)}
        tabIndex={0}
      >
        {title}
        <Icon
          label="Dropdown Icon"
          type={"t2u-chevron-right"}
          rotateDeg="90"
          size={12}
          className="t2-dropdown__icon"
        />
      </div>
      {isOpen && (
        <div className="t2-dropdown__content">
          <ul className="t2-dropdown__options">
            {options?.map((option: FilterOption, index: number) => {
              const id = option?.id;
              const title = option?.title;
              const isChecked = selectedOptions?.find && selectedOptions?.find((selectedOption: FilterOption) => selectedOption?.id === id) ? true : false
              return (
                <li
                  key={`option-${title}-${index}`}
                  className="t2-dropdown__option"
                  onClick={() => handleOptionClick(option)}
                >
                  <span
                    className={`t2-dropdown__option-label ${
                      isChecked
                        ? "t2-dropdown__option-label--selected"
                        : ""
                    }`}
                  >
                    {title}
                  </span>
                    <input
                      type="checkbox"
                      className="t2-dropdown__option-checkbox"
                      style={{ pointerEvents: "none"}}
                      checked={isChecked}
                      onChange={() => handleOptionClick(option)}
                    />
                </li>
              );
            })}
          </ul>
          {multiSelect && (
            <div className="t2-dropdown__actions">
              <button
                className="t2-dropdown__clear-button"
                onClick={handleClearAll}
              >{labelClearAll}</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
